module.exports = __webpack_public_path__ + "static/media/thumb.0a2f0336.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/dukes-park-renovation/thumb.jpg
// module id = 43
// module chunks = 0